// extracted by mini-css-extract-plugin
module.exports = {"popupFieldComponent":"Claims_popupFieldComponent__s+iho","contactDetailsLink":"Claims_contactDetailsLink__DrOpt"};